import { Controls } from "@lottiefiles/react-lottie-player";
import React, { useEffect, useState } from "react";
import Select from "react-select/creatable";
import {
	customSelect as customStyles,
	customListSelect as customListStyles,
} from "../../misc/customStyle-ReactSelect";
import { QuestionType } from "../../types/QuestionsTypes";
import { QuestionTypes } from "./types";

const Question: React.FC<QuestionTypes> = ({
	editable,
	columns,
	current_question,
	setQuestions,
	questionsClone,
	isNew,
	listDoc,
}: QuestionTypes) => {
	const [selectedAnswer, setSelectedAnswer] = useState<any>();
	const [selectedSubCat, setSelectedSubCat] = useState<any>();
	const [questionsAux, setQuestionsAux] =
		useState<QuestionType[]>(questionsClone);
	// const [question, setQuestion] = useState<QuestionType>(current_question);

	const [docsOptions, setDocsOptions] = useState<
		{ label: string; value: number }[]
	>([]);

	useEffect(() => setSelectedSubCat(undefined), [selectedAnswer]);
	useEffect(() => {
		load_documents();
	}, []);

	const load_documents = () => {
		const options = listDoc.map((doc) => {
			return { label: doc.name, value: doc.id };
		});
		setDocsOptions(options);
	};

	useEffect(() => {
		setQuestions(questionsAux);
	}, [questionsAux]);

	const handleChangeQuestion = (newValue: any, type: string) => {
		setQuestionsAux((prevState) => {
			let newState = [...prevState];
			switch (type) {
				case "title":
					newState = prevState.map((question) => {
						if (question.id === current_question.id) {
							question.title = newValue;

							return question;
						}

						return question;
					});

					break;
				case "answers":
					newState = prevState.map((question) => {
						if (question.id === current_question.id) {
							let value = newValue;
							let result = true;

							if (question.checklist === 1) {
								const splited_value = value.split("//");

								if (splited_value.length === 2) {
									value =
										splited_value[0]
											.charAt(0)
											.toUpperCase() +
										splited_value[0].slice(1);
									result =
										splited_value[1]
											.toLowerCase()
											.trim() === "a"
											? true
											: false;
								}
							}

							question.answers!.push({
								id: question.answers.length,
								title: value,
								result: result,
								subCategories: [],
								documents: [],
							});

							setSelectedAnswer(
								question.answers[question.answers.length - 1],
							);
						}

						return question;
					});

					break;

				case "sub-categories":
					newState = prevState.map((question) => {
						if (question.id === current_question.id) {
							question.answers.map((ans: any) => {
								if (ans.id === selectedAnswer?.id) {
									const new_subcategory = {
										id: ans.subCategories.length,
										title: newValue,
										documents: [],
									};

									ans.subCategories.push(new_subcategory);
									setSelectedSubCat(new_subcategory);
								}

								return;
							});
						}
						return question;
					});
					break;
				case "sub-categories-documents":
					newState = prevState.map((question) => {
						if (question.id === current_question.id) {
							question.answers.map((ans: any) => {
								if (ans.id === selectedAnswer?.id) {
									ans.subCategories.map((item: any) => {
										//@ts-ignore
										if (item.id === selectedSubCat?.id) {
											//@ts-ignore
											item.documents.push(newValue);
										}
										return;
									});
								}
								return;
							});
						}

						return question;
					});
					break;

				case "justif":
					newState = prevState.map((question) => {
						if (question.id === current_question.id) {
							question.answers.map((ans: any) => {
								if (ans.id === selectedAnswer?.id) {
									ans.justif = newValue;
								}
								return;
							});
						}

						return question;
					});

					break;

				case "documents":
					newState = prevState.map((question) => {
						if (question.id === current_question.id) {
							question.documents!.push(newValue);
						}
						return question;
					});
			}
			prevState.map((quest) =>
				quest.id === current_question.id && !quest.new
					? (quest.edited = true)
					: quest,
			);

			return newState;
		});
	};

	const handleRemoveDocument = (id: number) => {
		setQuestionsAux((prevState) => {
			if (!current_question.documents) {
				current_question.documents = [];
			}

			return prevState.map((question) => {
				if (question.id === current_question.id) {
					const indexSelectedAnswer = question.answers.findIndex(
						(qt) => qt.id === selectedAnswer?.id,
					);
					const indexSelectedSubCat = question.answers[
						indexSelectedAnswer
					].subCategories.findIndex(
						(qt) => qt.id === selectedSubCat?.id,
					);
					const questionSubCat =
						question.answers[indexSelectedAnswer].subCategories[
							indexSelectedSubCat
						];
					const current_questionSubCatDocuments =
						current_question.answers[indexSelectedAnswer]
							.subCategories[indexSelectedSubCat].documents;
					questionSubCat.documents =
						current_questionSubCatDocuments!.filter(
							(subCatDoc) => subCatDoc !== id,
						);
					question.edited = true;
					if (!question.deleted_documents) {
						question.deleted_documents = [];
					}
					question.deleted_documents.push(id);
				}

				return question;
			});
		});

		const index = current_question.documents!.indexOf(id);
		load_documents();
	};

	return (
		<>
			{columns.map((column) => {
				switch (column.type) {
					case "title":
						return editable ? (
							<td className='title'>
								{
									<input
										type='text'
										defaultValue={column.value}
										placeholder='Digite o titulo'
										onBlur={(e) =>
											handleChangeQuestion(
												e.target.value,
												column.type,
											)
										}
										autoFocus={isNew}
									/>
								}
							</td>
						) : (
							<td className='title' title={column.value}>
								{column.value}
							</td>
						);
					case "answers":
						const answers_options = column.value.map(
							(answer: any) => {
								return {
									label: answer.title,
									value: answer,
									color: answer.result
										? "#47D230"
										: "#D23030",
								};
							},
						);

						return (
							<td id='custom-select'>
								<Select
									placeholder='Selecione uma opção'
									options={answers_options}
									classNamePrefix='react-select'
									className='select-container'
									value={
										selectedAnswer
											? //@ts-ignore
											  { label: selectedAnswer?.title }
											: undefined
									}
									styles={customStyles}
									onCreateOption={(newValue) =>
										editable
											? handleChangeQuestion(
													newValue,
													column.type,
											  )
											: undefined
									}
									onChange={(option, action) => {
										if (action.action === "select-option")
											//@ts-ignore
											setSelectedAnswer(option.value);
									}}
									noOptionsMessage={() =>
										"Sem Respostas cadastradas"
									}
								/>
							</td>
						);
					case "justif":
						return editable ? (
							<td id='justif-field'>
								{
									<input
										type='text'
										// @ts-ignore
										value={
											selectedAnswer?.justif === ""
												? ""
												: selectedAnswer?.justif
										}
										placeholder='Digite a justificativa'
										onChange={(e) =>
											handleChangeQuestion(
												e.target.value,
												column.type,
											)
										}
									/>
								}
							</td>
						) : (
							<td id='justif-field'>
								{selectedAnswer?.justif ||
									"Selecione uma resposta"}
							</td>
						);
					case "sub-categories":
						const suboptions = selectedAnswer?.subCategories.map(
							(answer: any) => {
								//@ts-ignore
								return { label: answer.title, value: answer };
							},
						);

						return (
							<td id='custom-select'>
								<Select
									placeholder='Selecione uma opção'
									options={suboptions}
									styles={customStyles}
									value={
										selectedSubCat
											? { label: selectedSubCat.title }
											: null
									}
									onCreateOption={(newValue) =>
										editable
											? handleChangeQuestion(
													newValue,
													column.type,
											  )
											: undefined
									}
									onChange={(newValue, action) => {
										if (action.action === "select-option")
											// @ts-ignore
											setSelectedSubCat(newValue.value);
									}}
									noOptionsMessage={() =>
										"Sem opções cadastradas"
									}
									onMenuOpen={() => {
										// document.querySelector();
									}}
								/>
							</td>
						);
					case "sub-categories-documents":
						const subCat_docs = listDoc?.filter((document) =>
							selectedSubCat?.documents.includes(document.id),
						);

						return (
							<td id='document-select'>
								<Select
									placeholder='Selecione uma opção'
									options={docsOptions}
									styles={
										subCat_docs.length < 2
											? customStyles
											: customListStyles
									}
									isMulti
									value={subCat_docs?.map((doc) => {
										return {
											label: doc.name,
											value: doc.id,
										};
									})}
									onChange={(newValue, action) => {
										if (action.action === "select-option")
											handleChangeQuestion(
												action.option!.value,
												"sub-categories-documents",
											);
										if (action.action === "remove-value") {
											handleRemoveDocument(
												action.removedValue.value,
											);
										}
									}}
									isDisabled={!editable}
									noOptionsMessage={() =>
										"Sem Respostas cadastradas"
									}
								/>
							</td>
						);
					case "documents":
						console.log(current_question);

						const question_docs = listDoc?.filter((document) => {
							if (current_question.documentsTag) {
								return current_question.documentsTag.includes(
									document.id,
								);
							}
						});

						return (
							<td id='custom-select'>
								<Select
									placeholder='Selecione uma opção'
									options={docsOptions}
									styles={
										question_docs.length <= 2
											? customStyles
											: customListStyles
									}
									isMulti
									value={question_docs?.map((doc) => {
										return {
											label: doc.name,
											value: doc.id,
										};
									})}
									onChange={(newValue, action) => {
										if (action.action === "select-option")
											handleChangeQuestion(
												action.option!.value,
												"documents",
											);
										if (action.action === "remove-value") {
											handleRemoveDocument(
												action.removedValue.value,
											);
										}
									}}
									isDisabled={!editable}
									noOptionsMessage={() =>
										"Sem Respostas cadastradas"
									}
								/>
							</td>
						);
				}
			})}
		</>
	);
};

export default Question;
